<template>
  <d-modal v-if="showModal" size="lg">
    <d-modal-header :close="false">
      <d-modal-title>Invite Merchant</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div>
        <odd-label>Business Name</odd-label>
        <d-input
          v-model="businessName"
          class="mb-2"
        />

        <odd-label>Primary Contact</odd-label>
        <d-input
          v-model="primaryContact"
          class="mb-2"
        />

        <odd-label>Email Address</odd-label>
        <d-input
          v-model="email"
          class="mb-2"
        />

      </div>
      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose">
          Cancel
        </d-button>
        <async-button
          @click="insertMerchant"
          text="Save"
          loadingText="saving..."
          :loading="saving"
        />
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  data() {
    return {
      saving: false,
      businessName: "",
      primaryContact: "",
      email: "",
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  watch: {
    showModal() {
      this.resetForm();
    }
  },
  methods: {
    resetForm() {
      this.businessName = "";
      this.primaryContact = "";
      this.email = "";
    },
    handleClose(event) {
      this.$emit("close", event);
    },
    insertMerchant() {

        this.saving = true;
        const merchant = {
          name: this.businessName,
          primary_contact: this.primaryContact,
          primary_contact_email: this.email
        };
        this.$store
          .dispatch("merchants/insert", merchant)
          .then(result => {
            this.saving = false;
            this.$emit("dataUpdated");
            this.handleClose();
          });

    }
  }
};
</script>

<style></style>
